const getVendorTiers = state => {
  return state.vendorTiers;
};

export default {
  getVendorTiers,
};
